import API_PATH from '../../../config/API_PATH'
import { SHWE_VAULT_HISTORY, SHWE_VAULT_OPEN, SHWE_VAULT_STATUS } from './contants'

export const getShweVaultStatus = data => {
	return {
		type: SHWE_VAULT_STATUS,
		data,
		meta: {
			method: 'GET',
			url: API_PATH.shweVaultStatus,
			query: data.query || {},
			callback: data.callback || null
		},
	}
}
export const postShweVaultOpen = data => {
	return {
		type: SHWE_VAULT_OPEN,
		data,
		meta: {
			method: 'POST',
			url: API_PATH.shweVaultOpen,
			query: data.query || {},
			callback: data.callback || null
		},
	}
}

export const getShweVaultHistory = data => {
	return {
		type: SHWE_VAULT_HISTORY,
		data,
		meta: {
			method: 'GET',
			url: API_PATH.loyaltyPointHistory,
			query: data.query || {},
			callback: data.callback || null
		},
	}
}
